'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral([''], ['']);

exports.PlatMapComponent = PlatMapComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _bduiCoremap = require('@bd/bdui-coremap');

var _bduiCoremap2 = _interopRequireDefault(_bduiCoremap);

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable global-require */

var defaultStyles = (0, _bduiStyles.css)(_templateObject);

var polygonStatusStyles = {
  home: {
    active: {
      color: 'rgb(0, 128, 255)'
    },
    sold: {
      color: 'rgb(255, 0, 0)'
    },
    'under-construction': {
      color: 'rgb(0, 128, 255)'
    },
    pending: {
      color: 'rgb(233, 103, 24)'
    },
    default: {
      color: 'rgb(0, 128, 255)'
    }
  },
  lot: {
    active: {
      color: 'rgb(0, 128, 255)'
    },
    sold: {
      color: 'rgb(255, 0, 0)'
    },
    'under-construction': {
      color: 'rgb(0, 128, 255)'
    },
    pending: {
      color: 'rgb(233, 103, 24)'
    },
    default: {
      color: 'rgb(29, 214, 19)'
    }
  },
  default: {
    color: 'rgb(72, 82, 91)',
    fillOpacity: 0.43
  },
  available: {
    color: 'rgb(0, 128, 255)'
  },
  sold: {
    color: 'rgb(255, 0, 0)'
  },
  pending: {
    color: 'rgb(233, 103, 24)'
  },
  future: {
    color: 'rgb(233, 103, 24)'
  }
};

var otherLabels = {
  available: 'Available',
  sold: 'Sold',
  future: 'Future Phase',
  other: 'Other'
};

var getTooltip = function getTooltip(polygon) {
  var lotID = _lodash2.default.get(polygon, 'geometry.lotID', 'other');
  var customHover = _lodash2.default.get(polygon, 'geometry.customHover');
  var status = _lodash2.default.get(polygon, 'geometry.placeholder.status');

  return status === 'Other' && customHover ? customHover : status || _lodash2.default.get(otherLabels, lotID, otherLabels.other);
};

function PlatMapComponent(props) {
  var className = props.className,
      community = props.community,
      homes = props.homes,
      lots = props.lots,
      otherPopup = props.otherPopup,
      _popup = props.popup,
      shapeStatusStyles = props.shapeStatusStyles,
      shapes = props.shapes,
      tooltip = props.tooltip;

  var markers = !shapes ? [].concat(_toConsumableArray(homes), _toConsumableArray(lots)) : undefined;
  var statusStyles = _lodash2.default.merge(polygonStatusStyles, shapeStatusStyles);
  var polygons = void 0;

  if (shapes) {
    polygons = _lodash2.default.get(community, 'zPlatMap.geoJSON', []).map(function (polygon) {
      var marker = [].concat(_toConsumableArray(homes), _toConsumableArray(lots)).find(function (property) {
        return property._id === _lodash2.default.get(polygon, 'geometry.lotID');
      });
      var style = statusStyles.default;
      if (marker) {
        var type = marker.isLot ? 'lot' : 'home';
        var status = marker.isModel ? 'model' : marker.status || '';

        style = _lodash2.default.get(statusStyles, type + '.' + (0, _bdcoreUtilities.Slugify)(status), _lodash2.default.get(statusStyles, type + '.default'));

        return _extends({}, polygon, {
          marker: marker,
          style: style,
          tooltip: tooltip(marker),
          popup: function popup(_ref) {
            var m = _ref.marker;
            return _popup(m);
          }
        });
      } else if (_lodash2.default.has(statusStyles, '' + _lodash2.default.get(polygon, 'geometry.lotID'))) {
        style = _lodash2.default.get(statusStyles, '' + _lodash2.default.get(polygon, 'geometry.lotID'));
      }

      return _extends({}, polygon, {
        tooltip: getTooltip(polygon),
        description: _lodash2.default.get(polygon, 'geometry.customClick'),
        style: style,
        popup: function popup(_ref2) {
          var m = _ref2.marker;
          return otherPopup(m);
        }
      });
    });
  }

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'div',
      { className: 'PlatMap_wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'PlatMap_inner' },
        _react2.default.createElement(
          _bduiCoremap2.default,
          Object.assign({}, props, {
            markers: markers,
            center: _lodash2.default.get(community, 'zPlatMap.center'),
            polygons: polygons,
            bounds: _lodash2.default.get(community, 'zPlatMap.anchors'),
            boundsOptions: {
              padding: [0, 0]
            },
            hideTiles: !!_lodash2.default.get(community, 'zplathidemap'),
            zoomDisabled: !!_lodash2.default.get(community, 'zplatdisablescrollzoom')
          }),
          function () {
            var ImageTransform = require('./ImageTransform').default;
            if (!!_lodash2.default.get(community, 'zPlatMap.anchors') && !!_lodash2.default.get(community, 'zPlatMap.image')) {
              return _react2.default.createElement(ImageTransform, {
                anchors: _lodash2.default.get(community, 'zPlatMap.anchors'),
                image: (0, _bdcoreUtilities.buildThumbnailUrl)(_lodash2.default.get(community, 'zPlatMap.image'), { width: 2000, height: 2000, preserve: true }),
                opacity: _lodash2.default.get(community, 'zPlatMap.opacity', 100) / 100
              });
            }
            return null;
          }
        )
      )
    )
  );
}

var stylePropType = _propTypes2.default.shape({
  stroke: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  weight: _propTypes2.default.number,
  opacity: _propTypes2.default.number,
  fill: _propTypes2.default.string,
  fillOpacity: _propTypes2.default.number
});

PlatMapComponent.propTypes = {
  className: _propTypes2.default.string,
  community: _propTypes2.default.object.isRequired,
  homes: _propTypes2.default.arrayOf(_propTypes2.default.object.isRequired),
  lots: _propTypes2.default.arrayOf(_propTypes2.default.object),
  otherPopup: _propTypes2.default.func,
  popup: _propTypes2.default.func,
  shapes: _propTypes2.default.bool,
  shapeStatusStyles: _propTypes2.default.shape({
    home: _propTypes2.default.shape({
      active: stylePropType,
      sold: stylePropType,
      under_construction: stylePropType,
      pending: stylePropType,
      default: stylePropType
    }),
    lot: _propTypes2.default.shape({
      active: stylePropType,
      sold: stylePropType,
      under_construction: stylePropType,
      pending: stylePropType,
      default: stylePropType
    })
  }),
  tooltip: _propTypes2.default.func
};

PlatMapComponent.defaultProps = {
  className: undefined,
  homes: [],
  lots: [],
  otherPopup: function otherPopup(poly) {
    return !poly.tooltip && !poly.description ? null : _react2.default.createElement(
      'div',
      null,
      poly.tooltip,
      ' ',
      poly.description && _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('hr', null),
        ' ',
        poly.description
      )
    );
  }, // eslint-disable-line react/prop-types,max-len
  popup: function popup(_ref3) {
    var marker = _ref3.marker;
    return _react2.default.createElement(
      'div',
      null,
      marker._id
    );
  }, // eslint-disable-line react/prop-types
  shapeStatusStyles: {},
  shapes: true,
  tooltip: function tooltip(marker) {
    return _react2.default.createElement(
      'span',
      null,
      marker._id
    );
  } // eslint-disable-line react/prop-types
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(PlatMapComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-platmap/build/PlatMap.js
// module id = 1116
// module chunks = 0